import { useModalStore } from 'hooks/stores/useModalStore'
import { LegacyAntdModal } from 'components/LegacyAntdModal/LegacyAntdModal'

export const GlobalModal = () => {
  const { openModal, closeModal, ...modalInfo } = useModalStore()

  if (!modalInfo.modal) {
    return null
  }

  // Modals can also use custom modals (like components/Modal/Modal.tsx) instead of the global modal wrapper
  if (modalInfo.customModal) {
    return <modalInfo.modal {...modalInfo.modalProps} closeModal={closeModal} />
  }

  return (
    <LegacyAntdModal centered visible onCancel={closeModal} {...modalInfo.modalOptions}>
      <modalInfo.modal {...modalInfo.modalProps} closeModal={closeModal} />
    </LegacyAntdModal>
  )
}
